import WizardRegistrationFinal from './container'
export { WizardRegistrationFinal }
export default WizardRegistrationFinal